import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { TransitionContainerNoExit } from '../../components/Transition/TranstionContainer';

import CheckIcon from '../../components/Svg/CheckIcon';
import { copyFor } from '../../copy/copy';

const Container = styled.div`
    width: 100%;
    background-color: #fafafa;
    padding: 20px;
`;

const QuestionText = styled.div`
    font-family: Averta;
    font-size: 16px;
    line-height: 1.28;
    color: #000000;
    font-weight: bold;
    text-align: left;
    margin: 0 0 6px 0;

    @media (max-width: 38em) {
        font-size: 14px;
        line-height: 1.2;
    }

    @media (max-width: 30em) {
        font-size: 16px;
        line-height: 1.28;
    }
`;

const AnswersWrapper = styled.div`
    clear: left;
    margin: 0 -8px;
    margin-top: 12px;
    float: left;
    width: calc(100% - 15px);
    position: absolute;
    bottom: 5px;
    left: 15px;

    @media (max-width: 30em) {
        width: calc(100% - 30px);
    }
`;

const AnswerBar = styled.div`
    text-align: center;
    border-radius: 4px;
    margin: 0 8px 10px 8px;
    padding: 0 8px;
    float: left;
    position: relative;
    height: ${props =>
        props.noOfAnswers < 4
            ? props => (props.noOfAnswers === 2 ? '46px' : '36px')
            : '33px'};
    width: calc(100% - 16px);
    border: ${props =>
        props.isCorrect
            ? 'solid 3px #ff245e'
            : props => (props.answerAnswered ? 'solid 3px #0b2947' : 'solid 1px #ccc')};
    color: ${props => (props.isCorrect ? '#ff245e' : '#000')};
    opacity: ${props => (props.isCorrect || props.answerAnswered ? '1' : '0.4')};

    @media (max-width: 30em) {
        width: 100%;
        margin-bottom: 14px;
        height: ${props =>
            props.noOfAnswers < 4
                ? props => (props.noOfAnswers === 2 ? '56px' : '48px')
                : '40px'};
    }
`;

const IconWrapper = styled.div`
    width: 14px;
    height: 14px;
    position: absolute;
    left: calc(50% - 7px);
    bottom: -8px;
    border-radius: 100%;
    background-color: #ff245e;
    line-height: 12px;
`;

const CloseIcon = styled.div`
    width: 17px;
    height: 23px;
    transform: rotate(45deg);
    font-family: Averta;
    font-size: 16px;
    line-height: 100%;
    text-align: left;
    color: #fff;
`;

const IconWrapperAnswered = styled.div`
    width: 14px;
    height: 14px;
    position: absolute;
    left: calc(50% - 7px);
    bottom: -8px;
    border-radius: 100%;
    background-color: #0b2947;
    line-height: 12px;
`;

const PercentageBar = styled.div`
    font-size: 8px;
    font-weight: bold;
    line-height: 2.2;
    letter-spacing: 2px;
    text-align: center;
    position: relative;
    transform: translateY(-50%);
    top: 50%;
`;

const PercentageText = styled.div`
    font-size: ${props =>
        props.noOfAnswers === 4
            ? '9px'
            : props => (props.noOfAnswers === 3 ? '10px' : '12px')};
    font-weight: 600;
    line-height: 0.92;
    letter-spacing: 0;
    text-transform: ${props => (props.makeUppercase ? 'uppercase' : 'none')};

    @media (max-width: 30em) {
        font-size: 13px;
        line-height: 0.9;
    }
`;

const questionText = (feedbackText, noOfAnswers, isMobileResolution) => {
    if (!isMobileResolution) {
        const charLimit = noOfAnswers > 2 ? (noOfAnswers === 3 ? 64 : 44) : 120;
        if (feedbackText) {
            return feedbackText.length > charLimit
                ? feedbackText.substring(0, charLimit) + '...'
                : feedbackText;
        }
    }
    return feedbackText;
};

const QuizSuccess = props => (
    <TransitionContainerNoExit zIndex={15}>
        <Container>
            <QuestionText title={props.feedbackText}>
                {props.answeredCorrect
                    ? copyFor('feedback', 'correct', 'quiz')
                    : copyFor('feedback', 'incorrect', 'quiz')}
                {questionText(
                    props.feedbackText,
                    props.noOfAnswers,
                    props.isMobileResolution
                )}
            </QuestionText>
            <AnswersWrapper>
                {props.results.map(r => (
                    <AnswerBar
                        key={r.id}
                        isCorrect={r.isCorrect}
                        answerAnswered={r.answerAnswered}
                        noOfAnswers={r.noOfAnswers}
                    >
                        <PercentageBar>
                            <PercentageText
                                makeUppercase={
                                    props.makeUppercase.length === r.noOfAnswers
                                }
                                noOfAnswers={r.noOfAnswers}
                            >
                                {r.text}
                            </PercentageText>
                        </PercentageBar>
                        {r.isCorrect && (
                            <IconWrapper>
                                <CheckIcon width={8} height={8} />
                            </IconWrapper>
                        )}
                        {r.answerAnswered && !r.isCorrect && (
                            <IconWrapperAnswered>
                                <CloseIcon>+</CloseIcon>
                            </IconWrapperAnswered>
                        )}
                    </AnswerBar>
                ))}
            </AnswersWrapper>
        </Container>
    </TransitionContainerNoExit>
);

QuizSuccess.propTypes = {
    results: PropTypes.array.isRequired,
    feedbackText: PropTypes.string,
    answeredCorrect: PropTypes.bool.isRequired,
    makeUppercase: PropTypes.array.isRequired,
    noOfAnswers: PropTypes.number.isRequired,
    isMobileResolution: PropTypes.bool.isRequired
};

export default connect(state => {
    return {
        isMobileResolution: state.widget.isMobileResolution
    };
})(QuizSuccess);
